import * as types from '../constants/actionTypes'

// Shape of each option: year/make/model/trim
export interface VehicleOption {
  year: string
  make: string
  model: string
  trim: string
}

// State structure
interface VehicleOptionsState {
  isLoading: boolean
  data: VehicleOption[]
  error: string | null
}

const initialState: VehicleOptionsState = {
  isLoading: false,
  data: [],
  error: null,
}

// Reducer
export default function vehicleOptions(
  state = initialState,
  action: any
): VehicleOptionsState {
  switch (action.type) {
    case types.RequestVehicleOptions:
      return { ...state, isLoading: true, error: null }
    case types.RequestVehicleOptionsSuccess:
      return { ...state, isLoading: false, data: action.payload }
    case types.RequestVehicleOptionsFailure:
      return { ...state, isLoading: false, error: action.error }
    default:
      return state
  }
}
